import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'vant/lib/index.css'
import './styles/vant-theme.css'

import { NavBar, Swipe, SwipeItem, Button, Tabbar, TabbarItem, Icon, Image, Tag, Form, Field, Popup, Picker, Toast, Search, Row, Col, Cell, CellGroup, Dialog,
    Checkbox, CheckboxGroup, DatetimePicker, Tabs, Tab, Calendar, Radio, RadioGroup, Grid, GridItem, Empty, ImagePreview, Loading, ActionSheet, Divider, Overlay } from 'vant'

const app = createApp(App)
app.use(router)
app.use(NavBar)
app.use(Swipe)
app.use(SwipeItem)
app.use(Button)
app.use(Tabbar)
app.use(TabbarItem)
app.use(Icon)
app.use(Image)
app.use(Tag)
app.use(Form)
app.use(Field)
app.use(Popup)
app.use(Picker)
app.use(Toast)
app.use(Search)
app.use(Row)
app.use(Col)
app.use(Cell)
app.use(CellGroup)
app.use(Dialog)
app.use(Checkbox)
app.use(CheckboxGroup)
app.use(DatetimePicker)
app.use(Tabs)
app.use(Tab)
app.use(Calendar)
app.use(Radio)
app.use(RadioGroup)
app.use(Grid)
app.use(GridItem)
app.use(Empty)
app.use(ImagePreview)
app.use(Loading)
app.use(ActionSheet)
app.use(Divider)
app.use(Overlay)

// 全局注册自定义组件
import PageLoading from './components/PageLoading.vue'
import ErrorPage from './components/ErrorPage.vue'

app.component('PageLoading', PageLoading)
app.component('ErrorPage', ErrorPage)

app.mount('#app')
